import { render, staticRenderFns } from "./StorageCharges.vue?vue&type=template&id=41906325&"
import script from "./StorageCharges.vue?vue&type=script&lang=js&"
export * from "./StorageCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports